// @flow

import {connect} from 'react-redux';

import {objectsToFlatArray} from 'app/utils/redux';
import {fetchProcessVersions} from 'app/process/actions';
import type {StoreShapeType} from 'app/reducers/types';
import {type ProcessVersionType} from 'app/process/types';
import {
  VersionsSidebarFactory,
  type SpecificVersionsSidebarOwnProps,
  type SpecificVersionsSidebarStateProps,
} from 'app/components/general/VersionsSidebar';

const mapStateToProps = (state, {objectId}): StateProps => {
  const processVersions =
    objectId && state.processArea.getIn(['versions', objectId.toString()]);

  return {
    contentType: 'process',
    moreToLoad: !!(processVersions && processVersions.get('next')),
    versions:
      typeof processVersions !== 'undefined'
        ? // $FlowFixMe
          objectsToFlatArray(processVersions)
        : [],
  };
};

type OwnProps = SpecificVersionsSidebarOwnProps;

type StateProps = SpecificVersionsSidebarStateProps<ProcessVersionType>;

type DispatchProps = {|
  loadVersions: AsyncAction<typeof fetchProcessVersions, Promise<void>>,
  loadMoreVersions: AsyncAction<typeof fetchProcessVersions, Promise<void>>,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const VersionsSidebarComponent = VersionsSidebarFactory<ProcessVersionType>();

export const ProcessVersionsSidebar = connect<
  Props,
  OwnProps,
  StateProps,
  _,
  StoreShapeType,
  _
>(mapStateToProps, {
  loadVersions: fetchProcessVersions,
  loadMoreVersions: fetchProcessVersions,
})(VersionsSidebarComponent);
